import React from 'react';
import { X, Navigation } from 'lucide-react';

interface LocationPermissionModalProps {
  isOpen: boolean;
  error: string;
  onClose: () => void;
  onRequestPermission: () => void;
}

export const LocationPermissionModal: React.FC<LocationPermissionModalProps> = ({
  isOpen,
  error,
  onClose,
  onRequestPermission
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg max-w-md w-full p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-gray-800">Location Access</h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100">
            <X className="w-5 h-5 text-gray-600" />
          </button>
        </div>
        
        <div className="mb-6">
          <div className="flex items-center justify-center mb-4">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
              <Navigation className="w-8 h-8 text-blue-600" />
            </div>
          </div>
          
          <p className="text-gray-600 mb-4 text-center">{error}</p>
          
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
            <p className="text-sm text-blue-800 text-center">
              When you click "Allow Location Access", your browser will ask for permission to use your device's location.
            </p>
          </div>
          
          <p className="text-sm text-gray-500 text-center">
            Please tap "Allow" when your browser asks for location permission.
          </p>
        </div>
        
        <div className="flex space-x-3">
          <button
            onClick={onClose}
            className="flex-1 py-2 px-4 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onRequestPermission}
            className="flex-1 py-2 px-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Allow Location Access
          </button>
        </div>
      </div>
    </div>
  );
};

export default LocationPermissionModal;
